// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1152) return "static/chunks/1152-77c58ebef3833fb0.js";
	if (chunkId === 4519) return "static/chunks/4519-16d000cf0c85d78a.js";
	if (chunkId === 4721) return "static/chunks/4721-c2e6b0a79cf13952.js";
	if (chunkId === 1329) return "static/chunks/1329-9af8a2d210cddd94.js";
	if (chunkId === 7120) return "static/chunks/7120-abdf80e3013e3d9a.js";
	if (chunkId === 2270) return "static/chunks/2270-3b6ced755fc65646.js";
	if (chunkId === 9965) return "static/chunks/9965-55900cadd23224a7.js";
	if (chunkId === 4598) return "static/chunks/4598-3f81dc994f3cf262.js";
	if (chunkId === 9824) return "static/chunks/9824-d41215fa113048e1.js";
	if (chunkId === 4834) return "static/chunks/4834-fbad9fda973ed8f1.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"3200":"fec483df","5436":"72a30a16","9910":"bf41aa9e"}[chunkId] || chunkId) + "." + {"1336":"8155238b8a485a1c","2486":"63efc11725c5d2e6","2838":"92972069ca97827b","2983":"1bdcebf605110c91","3200":"7ae2b2298212fde5","3661":"cb5a53a2442a8772","5436":"32fe587da14d0cf8","6710":"4179a8ffc42a375e","9466":"e1e52421ee0c639e","9910":"b9b5de5c66079c40"}[chunkId] + ".js";
};